<template>
  <p class="jom-dispquote">
    <component :is="'jo' + item.name" v-for="item in data" v-bind:key="item.index" v-bind:data="item.data"></component>
  </p>
</template>

<script>
  export default {
    props: [
      'data'
    ]
  }
</script>
<style lang="scss" scoped>
  .jom-dispquote{
    font-weight: bold;
    margin: 0 4em 1rem 4em;
    p {
      text-indent: 0px;
      margin: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/common/dispquote.vue